import {
  put, takeLatest, takeEvery, select, all,
} from 'redux-saga/effects';
import {
  TeammoApi,
  normalize,
  compilePaginationObject,
} from 'app/utils/redux/helpers';
import {
  bulkImportSchema,
  bulkImportListSchema,
  organisationDataImportSchema,
} from 'app/utils/redux/schemas';
import { handleError } from 'app/utils/handlers/handleError';
import { loadingStart, loadingFinish } from 'app/ducks/loading/actions';
import { sagaActions } from 'app/ducks/bulkImports/actions';
import { BulkImportsActionTypes as types } from 'app/ducks/bulkImports/types';

function* createBulkImportSaga(action): any {
  yield put(sagaActions.createBulkImportPending(action.payload.data));
  const [error, response] = yield (
    yield TeammoApi(yield select())
  ).bulkImports.create(action.payload.data);

  if (response) {
    const normalizedResponse = normalize(response, bulkImportSchema);

    yield put(sagaActions.createBulkImportSuccess(normalizedResponse));
    if (action.payload?.redirect !== undefined) {
      action.payload.redirect(response.data.connectionRun?.id);
    }
  } else {
    yield put(
      handleError(
        error,
        sagaActions.createBulkImportFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
}

function* updateBulkImportSaga(action): any {
  yield put(sagaActions.updateBulkImportPending(action.payload));
  const [error, response] = yield (yield TeammoApi(yield select())).bulkImports.update(
    action.payload,
  );

  if (response) {
    const normalizedResponse = normalize(response, bulkImportSchema);

    yield put(sagaActions.updateBulkImportSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.updateBulkImportFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
}

function* getBulkImportSaga(action): any {
  yield put(sagaActions.getBulkImportPending());
  const [error, response] = yield (yield TeammoApi(yield select())).organisationDataImports.show(
    action.payload,
  );
  if (response) {
    const normalizedResponse = normalize(response, organisationDataImportSchema);

    yield put(sagaActions.getBulkImportSuccess(normalizedResponse));
    return normalizedResponse.entities.organisationDataImports[
      normalizedResponse.result
    ];
  }
  yield put(
    handleError(
      error,
      sagaActions.getBulkImportFailed(
        _.isEmpty(error) ? {} : error.response.data.errors,
      ),
    ),
  );
  return null;
}

function* getAllBulkImportsSaga(action): any {
  yield put(
    sagaActions.getAllBulkImportsPending(
      action.payload.compile ? action.payload.pagination : {},
    ),
  );
  yield put(loadingStart());

  const paginationObject = action.payload.compile
    ? compilePaginationObject(
      yield select((state) => state.bulkImports.pagination),
    )
    : action.payload.pagination;

  const [error, response] = yield (yield TeammoApi(yield select())).bulkImports.list(
    action.payload.organisationId,
    paginationObject,
  );

  if (response) {
    const normalizedResponse = normalize(response, bulkImportListSchema);

    yield put(
      sagaActions.getAllBulkImportsSuccess(normalizedResponse, response.meta),
    );
    yield put(loadingFinish());
  } else {
    yield put(
      error,
      sagaActions.getAllBulkImportsFailed(
        _.isEmpty(error) ? {} : error.response.data.errors,
      ),
    );
  }
}

/* ********************************* SAGA WATCHERS ********************************* */

function* createBulkImportSagaWatcher(): any {
  yield takeLatest(types.CREATE_BULK_IMPORT_REQUESTED, createBulkImportSaga);
}

function* updateBulkImportSagaWatcher(): any {
  yield takeLatest(types.UPDATE_BULK_IMPORT_REQUESTED, updateBulkImportSaga);
}

function* getBulkImportSagaWatcher(): any {
  yield takeEvery(types.GET_BULK_IMPORT_REQUESTED, getBulkImportSaga);
}

function* getAllBulkImportsSagaWatcher(): any {
  yield takeLatest(
    types.GET_ALL_BULK_IMPORTS_REQUESTED,
    getAllBulkImportsSaga,
  );
}

export default function* root(): any {
  yield all([
    createBulkImportSagaWatcher(),
    updateBulkImportSagaWatcher(),
    getBulkImportSagaWatcher(),
    getAllBulkImportsSagaWatcher(),
  ]);
}
